// @flow

import React, { Component } from 'react';
import { TransitionGroup } from 'react-transition-group';
import DraggablePiece from './DraggablePiece';
import type { PieceData } from './types';

type Props = {
  activePiece: PieceData,
  fieldWidth: number,
};

class PuzzleStack extends Component<Props> {
  render(): ?React$Element<any> {
    const { activePiece, fieldWidth } = this.props;

    if (!activePiece) return null;

    return (
      <div className="puzzle__stack h-24 w-24">
        <TransitionGroup>
          <DraggablePiece pieceData={activePiece} fieldWidth={fieldWidth} />
        </TransitionGroup>
      </div>
    );
  }
}

export default PuzzleStack;
